const RUB = new Intl.NumberFormat('ru-RU');

export function fmtMoney(n: number, currency = '₽'): string {
  return RUB.format(Math.round(n)) + ' ' + currency;
}

export function fmtK(n: number): string {
  const abs = Math.abs(n);
  if (abs >= 1000) return Math.round(n / 1000) + 'к';
  return Math.round(n).toString();
}

export function fmtPct(ratio: number, digits = 0): string {
  return (ratio * 100).toFixed(digits) + '%';
}

export function fmtDate(iso: string): string {
  // ISO YYYY-MM-DD → DD.MM
  if (!iso) return '';
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return iso;
  return `${m[3]}.${m[2]}`;
}

export function todayIso(d: Date = new Date()): string {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}
